import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import type {BaseUrlsStrategyData} from '../../types/base-urls-data.type';
import {BaseUrlsStrategyService} from '../../BasePathStrategyService';


// const {err} = makeLogger({pathToCurrentFile: 'components/strategies/services/base-url-service/myse-base-urls.sevice.ts'});
@Service({id: 'mySeBaseUrlsStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<BaseUrlsStrategyService> {

  build(details: BaseUrlsStrategyData): BaseUrlsStrategyService {
      return new MySeBaseUrlsStrategyService(details);
  }
}

export class MySeBaseUrlsStrategyService extends BaseUrlsStrategyService{
  details: BaseUrlsStrategyData;

  constructor(details: BaseUrlsStrategyData) {
      super();
      this.details = details;
  }
  getBaseUrls(): BaseUrlsStrategyData {
      return this.details;
  }
}
